module.exports = __webpack_public_path__ + "img/show-content2.f298d343.png";